<template>
  <!-- 手机模板——列表页 -->
  <div class="doctor_base_contentL">
    <div ref='changeListStyle' class="DBL_list">

      <div class="DBL_list_inp">
        <a-input v-model="searchData" @input="searchDataFn()" ref="userNameInput" placeholder="请输入医生姓名搜索">
          <a-icon slot="prefix" type="search" />
        </a-input>
      </div>

      <div
        v-show="!searchData&&task_config.is_enable_tab==1&&task_config&&task_config.menu_tab&&task_config.menu_tab[0]"
        class="DBL_list_TAB">
        <div @click="changeListStyle(index)" v-for="(item,index) in task_config.menu_tab" :key="index"
          class="DBL_list_TAB_item">
          <span :class="{ckecked: index==changeListStyleNum}"
            :style="index==changeListStyleNum?'color:' + meeting_data.theme_color||'#1890ff':''"
            class="DBL_list_TABL_title">{{item.menu_title}}</span>
          <span v-show="index==changeListStyleNum" :style="'background:' + meeting_data.theme_color||'#1890ff'"
            class="DBL_list_TABL_line"></span>
        </div>
      </div>

      <div v-show="searchData" class="DBL_list_All DBL_list_TABSearch">
        <div class="DBL_list_Base">
          <div @click="goDecFn(speaker)" v-for="speaker in searchList" :key="speaker.specialist_id"
            class="DBL_list_item">
            <div class="DBL_list_itemL">
              <img width="100%" v-if='!speaker.head_path' height="100%" src="@/assets/noImg.webp" alt="">
              <img v-if='speaker.head_path' :src="speaker.head_path" alt="">
            </div>
            <div class="DBL_list_itemR">
              <div class="DBL_list_itemRT">{{removeBracesContent(speaker.name)}}</div>
              <div class="DBL_list_itemRB">{{speaker.hospital_name}}</div>
            </div>
          </div>
        </div>
      </div>

      <div :class="{noTable :task_config.is_enable_tab==2}" v-show="!searchData" @scroll="DBL_list_AllScroll()"
        class="DBL_list_All">

        <!-- <div class="DBL_list_Base_RBig">
          <div @click='scrollFn(list)' :class="{DBL_list_BaseSelect: list==checkNum}" v-for="(key,list) in dataList"
            :key="list">
            {{list}}</div>
        </div> -->

        <a-anchor @click="handleClick" class="DBL_list_Base_RBig DBL_list_Base_RBiganchor">
          <a-anchor-link class="no_default" v-for="(key,list)  in dataList" :key="'md'+list" :href="'#'+list"
            :title="list" />
        </a-anchor>

        <div class="DBL_list_Base_List">
          <div v-show="key[0]" v-for="(key,list) in dataList" :key="list" :id='list' ref='DBL_list_Base_List'
            class="DBL_list_Base">
            <div :id='"scroll_"+list' class="DBL_list_BaseBig">{{list}}</div>

            <div :id="speaker.specialist_id+'_doc'" @click="goDecFn(speaker)" v-for="speaker in key"
              :key="speaker.specialist_id" class="DBL_list_item">
              <div class="DBL_list_itemL">
                <img width="100%" v-if='!speaker.head_path' height="100%" src="@/assets/noImg.webp" alt="">
                <img v-if='speaker.head_path' :src="speaker.head_path" alt="">
              </div>
              <div class="DBL_list_itemR">
                <div class="DBL_list_itemRT">{{removeBracesContent(speaker.name)}}</div>
                <div class="DBL_list_itemRB">{{speaker.hospital_name}}</div>
              </div>
            </div>

          </div>
        </div>

      </div>

    </div>
    <slot></slot>

  </div>
</template>

<script>
import $ from 'jquery'
import { getSpecialist, } from '@/api/meetApi'
export default {
  name: "Article",
  props: ["index", 'meeting_data'],
  data() {
    return {
      checkNum: '',
      searchData: '',
      changeListStyleNum: 0,
      dataList: [],
      searchList: [],
      task_config: {}
    };
  },
  created() {
    this.get_experts()
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  mounted() {
    console.log(this.meeting_data);
    // window.addEventListener('scroll', this.DBL_list_AllScroll);
  },
  methods: {
    handleClick(e, link) {
      console.log(link);
      // 阻止点击的默认事件修改路由
      e.preventDefault();
      // if (link.href) {
      //   let ele = document.getElementById(link.href);
      //   ele && ele.scrollIntoView({ block: 'start', behavior: 'smooth' });
      // }
    },
    removeBracesContent(str) {
      return str.replace(/ *\{[^}]*\}/g, '');
    },
    DBL_list_AllScroll() {
      const element = document.querySelector('html');
      const offsetTop = element.scrollTop;
      localStorage.setItem('hisScroll', offsetTop);
      console.log(offsetTop);
    },
    initObserver() {
      let _this = this;
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // var dd = $("#" + entry.target.id).offset().top; 
            // _this.checkNum = entry.target.id; 
          }
        });
      }, { threshold: 1 });

      // 监听所有带有 ref="box" 的元素
      this.$refs.DBL_list_Base_List.forEach(box => {
        this.observer.observe(box);
      });
    },
    scrollFn(key) {
      this.checkNum = key
      var letter_top = $("#scroll_" + key).offset().top;
      console.log(letter_top);
      // if ($routeParams.meetingId >= 4) {
      letter_top = letter_top - 105
      // }
      $('body,html').animate({
        scrollTop: letter_top
      }, 300);
    },
    showHis() {
      let changeListStyleNum = JSON.parse(localStorage.getItem('changeListStyleNum'))
      if (!this.task_config.menu_tab[0]) {
        return
      }
      if (changeListStyleNum && changeListStyleNum.title == this.task_config.menu_tab[changeListStyleNum.index].menu_title) {
        if (changeListStyleNum.date > new Date().getTime() - 5 * 60 * 1000) {
          this.changeListStyleNum = changeListStyleNum.index
        } else {
          this.changeListStyleNum = 0
        }
      }
      console.log(this.changeListStyleNum);
      this.changeListStyle(this.changeListStyleNum)
    },
    changeStyleFN() {
      this.$refs.changeListStyle.style.background = "unset";
      this.$refs.changeListStyle.style.backgroundColor = "unset";
      if (this.task_config.list_style == 1) {
        console.log(this.$refs)
        this.$refs.changeListStyle.style.backgroundColor = this.meeting_data.background_color;
      }
      if (this.task_config.list_style == 2) {
        this.$refs.changeListStyle.style.background = 'url(' + this.meeting_data.background_img_path + ')';
      }
      if (this.task_config.list_style == 3) {
        this.$refs.changeListStyle.style.background = 'url(' + this.task_config.list_style_img_path + ')';
      }
      if (this.task_config.list_style == 4) {
        this.$refs.changeListStyle.style.backgroundColor = "#fafafa";
      }
    },
    async get_experts() {
      let _this = this
      let data = await getSpecialist({ meeting_id: this.meeting_data.id })
      this.task_config = data.payload.task_config
      this.changeStyleFN()
      if (this.task_config.is_enable_tab == 2) {
        this.dataList = this.task_config.all_group_specialist
        this.showHis()
        return
      }
      this.dataList = this.task_config.menu_tab[0].specialist_list
      setTimeout(() => {
        // _this.initObserver();
        let his_checkNum = JSON.parse(localStorage.getItem('checkNum'))
        if (his_checkNum && his_checkNum.type) { 
          if (his_checkNum.date > new Date().getTime() - 5 * 60 * 1000) {
            this.checkNum = his_checkNum.type
            let hisScroll = JSON.parse(localStorage.getItem('hisScroll'))
            if (hisScroll) { 
              console.log(hisScroll);
              $('body,html,#app').animate({
                scrollTop: hisScroll
              }, 0);
            }
          }
        }
      }, 200);
      this.showHis()
    },
    searchDataFn() {
      if (!this.searchData) {
        return
      }
      this.searchList = []
      this.task_config.all_specialist.forEach(item => {
        if (item.name.indexOf(this.searchData) > -1) {
          this.searchList.push(item)
        }
      });
      console.log(this.searchList);
    },
    changeListStyle(index) {
      this.changeListStyleNum = index
      this.dataList = this.task_config.menu_tab[index].specialist_list
      if (!this.task_config.menu_tab[0]) {
        return
      }
      localStorage.setItem('changeListStyleNum', JSON.stringify({ index: index, title: this.task_config.menu_tab[index].menu_title, date: new Date().getTime() }))
    },
    goDecFn(data) {
      localStorage.setItem('checkNum', JSON.stringify({ type: data.specialist_id, date: new Date().getTime() }))
      this.DBL_list_AllScroll();
      console.log(data);
      this.$router.push('/doctorItem?id=' + data.specialist_id + "&meeting_id=" + this.meeting_data.id)
    }
  }
};
</script>

<style lang="less" scoped>
.DBL_list_TABSearch {
  margin-top: 12px !important;
  border-radius: 12px !important;
  // max-height: calc(100vh - 69px) !important;
}
.DBL_list_TAB {
  height: 48px;
  background-color: #fff;
  margin-top: 12px;
  display: flex;
  border-radius: 12px 12px 0 0;
  .DBL_list_TAB_item {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    .ckecked {
      color: #1890ff;
    }
    .DBL_list_TABL_line {
      display: inline-block;
      width: 20px;
      border-radius: 2px;
      height: 2px;
      background-color: #1890ff;
      position: absolute;
      width: 20px;
      margin: auto;
      left: 0;
      right: 0;
      bottom: 10px;
    }
  }
}
.doctor_base_contentL {
  margin-right: 40px;
  width: 100%;
  min-height: 667px;
  // border: 1px solid #e5e6eb;
  border-radius: 8px;
}
.doctor_base_contentR {
  .DBR_data_itemT_inp,
  .ant-input {
    width: 120px;
    color: #222222;
  }
  :deep(.ant-input) {
    color: #222222;
  }
  .ant-checkbox-wrapper {
    color: #222222;
  }
  .DBR_data_item {
    padding: 16px;
    font-weight: 400;
    font-size: 14px;
    color: #585858;
    height: 112px;
    background: #f9fafc;
    border-radius: 2px;
    margin-bottom: 12px;
    display: flex;
    flex-direction: column;
  }
  .DBR_data_item:last-child {
    margin-bottom: 0;
  }
  .DBR_data_title {
    margin-right: 12px;
  }
  .DBR_data_must {
    color: red;
  }
  .DBR_data_itemT {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }
  .DBR_data_myimg {
    width: 160px;
    height: 90px;
  }
  .DBR_data {
    .DBR_data_item {
      display: flex;
    }
    padding-bottom: 24px;
    .DBR_data_add {
      width: 160px;
      margin-bottom: 16px;
      height: 40px;
      font-weight: 400;
      font-size: 12px;
      color: #222222;
      line-height: 17px;
      border-radius: 4px;
      border: 1px solid #e5e6eb;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  flex: 1;
  max-width: 560px;
  .DBR_B {
    border-bottom: 1px solid #eff0f2;
  }
  .DBR_title_boxBase {
    border-bottom: 1px solid #eff0f2;
  }
  .bottom_none {
    border-bottom: 0px solid #000;
  }
  .DBR_title_box {
    padding: 24px 0;
    display: flex;
    align-items: center;
  }
  .DBR_title_boxL {
    font-weight: 400;
    font-size: 14px;
    color: #222222;
  }
  .DBR_title_boxC {
    flex: 1;
    font-weight: 400;
    font-size: 13px;
    color: #86909d;
    margin-left: 12px;
  }
}
.DBL_list {
  // background: url("~@/assets/kv.jpg");
  background-size: 100% 100%;
  padding: 10px 12px;
  padding-bottom: 0;
  display: flex;
  flex-direction: column;
  .DBL_list_inp {
    :deep(.ant-input) {
      background: #ffffff;
      border-radius: 20px;
    }
  }
  .DBL_list_All {
    // max-height: calc(100vh - 117px);
    background-color: #fff;
    // overflow: auto;
    margin-bottom: 12px;
    border-radius: 0 0 12px 12px;
    .DBL_list_Base_List {
    }
    .DBL_list_Base_RBig {
      position: fixed;
      height: 70vh;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      font-weight: 400;
      font-size: 10px;
      color: #a9a9a9;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      z-index: 9;
    }
    .DBL_list_BaseSelect {
      color: #232323;
    }
    position: relative;
    // border: 1px solid #f1f3f4;
    // border-radius: 12px;
    // margin: 10px 0;
  }
  .DBL_list_Base {
    .DBL_list_BaseBig {
      position: absolute;
      left: 16px;
      top: 2px;
      font-weight: 500;
      font-size: 12px;
      color: #a9a9a9;
    }
    position: relative;
    height: 100%;
    padding: 0 16px;
    .DBL_list_item {
      .DBL_list_itemL {
        width: 56px;
        height: 56px;
        border-radius: 56px;
        overflow: hidden;
        margin-right: 12px;
        img {
          width: 100%;
          min-height: 100%;
        }
      }
      .DBL_list_itemR {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
      .DBL_list_itemRT {
        font-weight: 600;
        font-size: 14px;
        color: #232323;
      }
      .DBL_list_itemRB {
        font-weight: 400;
        font-size: 12px;
        color: #888888;
      }
      display: flex;
      padding: 17px 0;
      height: 88px;
      border-bottom: 1px solid #f1f3f4;
    }
  }
}
.DBL_list .noTable {
  margin-top: 10px;
  border-radius: 12px;
}
</style>

<style>
.DBL_list_Base_RBig .ant-anchor-ink {
  display: none !important;
}
.DBL_list_Base_RBig .ant-anchor-link {
  flex: 1;
  padding: 0 !important;
  text-align: center !important;
}
.DBL_list_Base_RBig .ant-anchor-wrapper {
  background-color: transparent !important;
}
.DBL_list_Base_RBig .ant-anchor-link-title {
  color: #797979 !important;
  font-weight: 500;
  font-size: 12px !important;
  text-align: center !important;
  width: 30px;
  margin-right: 5px;
  padding-top: 10px;
}
.DBL_list_Base_RBig .ant-anchor {
  height: 70vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  flex-direction: column;
}
.DBL_list_Base_RBig .ant-anchor-link-active .ant-anchor-link-title-active {
  color: #0485fd !important;
}
</style>